import { createQueryKeys } from '@lukemorales/query-key-factory';

export const configQueryKeys = createQueryKeys('config', {
  byRepo: (installationId: number, repoId: number) => [installationId, repoId],
});
